import { useTranslation } from 'react-i18next'
import { voteShares } from './assembly-utils'

/**
 * For / against / abstaining voices as one thin bar. Without any voice it is an
 * empty track, never a broken one.
 */
export function VoteBar({
    voicesFor,
    voicesAgainst,
    voicesAbstain,
    testId,
}: {
    voicesFor?: number | null
    voicesAgainst?: number | null
    voicesAbstain?: number | null
    testId: string
}) {
    const { t } = useTranslation('assemblies')
    const s = voteShares(voicesFor, voicesAgainst, voicesAbstain)
    if (s.total === 0) return null
    const label = t('card.voices', { for: voicesFor ?? 0, against: voicesAgainst ?? 0, abstain: voicesAbstain ?? 0 })
    return (
        <div className="min-w-24 max-w-40" data-testid={testId} title={label} aria-label={label} role="img">
            <div className="flex h-2 overflow-hidden rounded-full bg-muted">
                <div className="bg-success" style={{ width: `${s.for}%` }} data-testid={`${testId}-for`} />
                <div className="bg-destructive" style={{ width: `${s.against}%` }} data-testid={`${testId}-against`} />
                <div className="bg-muted-foreground/40" style={{ width: `${s.abstain}%` }} data-testid={`${testId}-abstain`} />
            </div>
            <div className="mt-0.5 text-[11px] tabular-nums text-muted-foreground">{label}</div>
        </div>
    )
}
